















import { defineComponent } from '@nuxtjs/composition-api'
import { ciTimes } from '~/icons/source/regular/times'
export default defineComponent({
  setup() {
    return {
      ciTimes
    }
  }
})
